import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import { t } from 'ember-intl'
import Icon from 'customer-flows/components/ui-kit/icon'
import Modal from 'customer-flows/components/ui-kit/modal'
import { command } from 'customer-flows/utils/core'

interface BookingAbandonmentCloseButtonSignature {
  Element: HTMLElement
}

export default class BookingAbandonmentCloseButton extends Component<BookingAbandonmentCloseButtonSignature> {
  @command('booking-abandonment') shouldConfirmClose: BookingAbandonmentCommands['shouldConfirmClose']
  @command('booking-abandonment') leave: BookingAbandonmentCommands['leave']

  @tracked isConfirmOpen = false

  @action
  onClose() {
    if (this.shouldConfirmClose()) {
      this.isConfirmOpen = true
      return
    }

    this.leave()
  }

  @action
  onContinue() {
    this.isConfirmOpen = false
  }

  @action
  onLeave() {
    this.isConfirmOpen = false
    this.leave()
  }

  <template>
    {{! @glint-ignore: wait until we can't declare custom elements in glint }}
    <il-button onClick={{this.onClose}} iconOnly={{true}} variant='ghost' small={{true}} ...attributes>
      <Icon @src='close' @description={{t 'common.close'}} class='text-neutrals-0' />
    </il-button>

    <Modal
      @isOpen={{this.isConfirmOpen}}
      @headerTitle={{t 'booking-abandonment.title'}}
      @onClose={{this.onContinue}}
      class='sm:il-modal:max-w-[400px]'
      data-testid='booking-abandonment-modal'
    >
      <:body>
        <p class='text-reg-para-16 text-neutrals-300'>{{t 'booking-abandonment.body'}}</p>
      </:body>
      <:footer>
        <div class='flex justify-end gap-3'>
          {{! @glint-ignore: wait until we can't declare custom elements in glint }}
          <il-button variant='secondary' small onClick={{this.onLeave}} data-testid='booking-abandonment-modal__leave'>
            {{t 'booking-abandonment.leave'}}
          </il-button>
          {{! @glint-ignore: wait until we can't declare custom elements in glint }}
          <il-button small onClick={{this.onContinue}} data-testid='booking-abandonment-modal__continue'>
            {{t 'booking-abandonment.continue'}}
          </il-button>
        </div>
      </:footer>
    </Modal>
  </template>
}
